import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
import _uniq from "lodash/uniq";
import _flatten from "lodash/flatten";
var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
import { computed, observable } from 'mobx';
import { Collection } from 'core/model/Collection';
import DeviceModel from './DeviceModel';
const SEARCHABLE_FIELDS = ['agentName', 'appliedLabels', 'device_manufacturer', 'device_name', 'deviceType', 'flowSource', 'flowType', 'id', 'ip_address', 'model', 'os_name', 'os_version', 'plan_name', 'sending_ips', 'serial_number', 'site_market_name', 'site_name', 'vendor'];
let DeviceCollection = (_dec = observable.ref, _dec2 = observable.ref, _dec3 = observable.ref, _dec4 = observable.ref, _class = class DeviceCollection extends Collection {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "memoryUtilQueryData", _descriptor, this);
    _initializerDefineProperty(this, "cpuUtilQueryData", _descriptor2, this);
    _initializerDefineProperty(this, "temperatureQueryData", _descriptor3, this);
    _initializerDefineProperty(this, "trafficQueryData", _descriptor4, this);
    this.useAsyncAdd = true;
    this.setMemoryUtilQueryData = () => {
      this.memoryUtilQueryData.forEach(result => {
        const device = this.get(result.device_id);
        if (device && device.get('memory_util') !== result.last_memory_util) {
          device.set('memory_util', result.last_memory_util);
        }
        if (device && device.get('memory_util_timeseries') !== result.sparklineData) {
          device.set('memory_util_timeseries', result.sparklineData);
        }
      });
    };
    this.setCpuUtilQueryData = () => {
      this.cpuUtilQueryData.forEach(result => {
        const device = this.get(result.device_id);
        if (device && device.get('cpu_util') !== result['last_total/instant']) {
          device.set('cpu_util', result['last_total/instant']);
        }
        if (device && device.get('cpu_util_timeseries') !== result.sparklineData) {
          device.set('cpu_util_timeseries', result.sparklineData);
        }
      });
    };
    this.setTemperatureQueryData = () => {
      this.temperatureQueryData.forEach(result => {
        const device = this.get(result.device_id);
        if (device) {
          device.set('temperature', {
            avg_instant: result.avg_instant,
            max_instant: result.max_instant,
            last_instant: result.last_instant
          });
        }
        if (device && device.get('temperature_timeseries') !== result.sparklineData) {
          device.set('temperature_timeseries', result.sparklineData);
        }
      });
    };
    this.setTrafficQueryData = () => {
      const {
        deviceNameIdHash
      } = this;
      this.trafficQueryData.forEach(result => {
        const id = deviceNameIdHash[result.i_device_name];
        const device = id ? this.get(id) : null;
        if (device && device.get('traffic') !== result.f_sum_both_bytes__k_last) {
          device.set('traffic', result.f_sum_both_bytes__k_last);
        }
        if (device && device.get('traffic_timeseries') !== result.sparklineData) {
          device.set('traffic_timeseries', result.sparklineData);
        }
      });
    };
  }
  get defaultSortState() {
    return {
      field: 'device_name',
      direction: 'asc'
    };
  }
  get secondarySort() {
    return this.defaultSortState;
  }
  get url() {
    return '/api/ui/devices';
  }
  get model() {
    return DeviceModel;
  }
  getFilterValues(model) {
    return SEARCHABLE_FIELDS.map(name => model[name] ?? model.get(name)).filter(value => value != null && value !== '');
  }
  get percentUnlabeled() {
    return this.isRequestActive('fetching') ? 0 : Math.floor(this.unlabeledDevices.length / this.size * 100);
  }
  get unlabeledDevices() {
    return this.models.filter(device => !device.hasLabels);
  }
  get deviceIdNameHash() {
    const hash = {};
    this.models.forEach(device => {
      hash[device.id] = device.get('device_name');
    });
    return hash;
  }
  get deviceNameIdHash() {
    const hash = {};
    this.unfiltered.forEach(device => {
      hash[device.get('device_name')] = device.id;
    });
    return hash;
  }

  // returns a unique array of label names for the selected models
  get selectedLabelNames() {
    if (!this.selectedSize) {
      return [];
    }
    const labels = _flatten(this.selectedArray.map(m => m.get('labels').map(l => l.name)));
    return _uniq(labels);
  }
  getLinkedDeviceModel(model) {
    if (model.get('device_bgp_type') === 'other_device') {
      return this.models.find(item => item.get('id') === model.get('use_bgp_device_id')?.toString());
    }
    return null;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "memoryUtilQueryData", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "cpuUtilQueryData", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "temperatureQueryData", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "trafficQueryData", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "percentUnlabeled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "percentUnlabeled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unlabeledDevices", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "unlabeledDevices"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deviceIdNameHash", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "deviceIdNameHash"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deviceNameIdHash", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "deviceNameIdHash"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedLabelNames", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedLabelNames"), _class.prototype), _class);
export default DeviceCollection;